<template>
  <!-- <div v-theme="'wide'" id="show-blogs"> -->
<div id="show-blogs">
      <h1>博客总览</h1>
      <!-- 搜索框 -->
      <input type="text" v-model="search" placeholder="搜索">
      <!-- 显示filter后的博客 -->
      <div v-for="blog in filteredBlogs" class="single-blog" :key="blog.id">
          <!-- 必须绑定v-bind:因为blog.id是v-bind进来的 -->
         <router-link :to="'/blog/'+blog.id">
             <h2 v-rainbow >{{blog.title | to-uppercase}}</h2>
         </router-link> 
          <article> 
            {{blog.content | snippet}}
        </article> 
      </div>      
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'show-blogs',
  data(){
      return {
          blogs:[],
          search:""
      }
  },
  created(){
      axios.get("https://floralblog-c0454-default-rtdb.firebaseio.com/posts.json")
      .then((response)=>{
        return response.data;
      }).then((data) =>{
          var blogsArray = [];
          for (let key in data){        
            data[key].id = key;  // id就是key 那串数字
            blogsArray.push(data[key]);
          }
          this.blogs = blogsArray;
      })
  },
  computed:{
      filteredBlogs:function(){
          return this.blogs.filter((blog)=>{
              return blog.title.match(this.search);
          })
      }
  },
  filters:{
      "to-uppercase": function(value){
          return value.toUpperCase();
      },
      "snippet":function(value){
    return value.slice(0,100) + "...";
    }
  },
  directives:{  
      'rainbow': {
          bind(el,binding,vnode){
                el.style.color = '#' + Math.random().
                toString(16).slice(2,8);
          }
      }
  }
}
</script>

<style>
#show-blogs{
    max-width: 800px;
    margin:0 auto;
}
.single-blog{
    padding: 20px;
    margin:20px;
    box-sizing: border-box;
    background-color: gray;
    border: 1px dotted #aaa;
}

#show-blogs a{
    color: gray;
    text-decoration: none;
}

input[type="text"]{
    padding: 8px;
    width: 100%;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/ShowBlogs.vue